<template>
    <!--结汇申请-->
  <div class="exchange-of-settement">
    <ab-list-query :isMenu="false">
        <template #right>
            <el-row :gutter="20">
                <el-col :span="4">
                    <el-input
                    placeholder="订单编号"
                    v-model.trim="formSearch.custOrderNo"
                    clearable
                    ></el-input>
                </el-col>
                <el-col :span="4">
                    <ab-select
                    v-model="formSearch.customerIdDesc"
                    url="/bas/basCustomer/pageList"
                    :urlData="{ name: formSearch.customerIdDesc, pageNum: 1, pageSize: 10, isEnabled: 1 }"
                    inputKey="name"
                    descKey="name"
                    placeholder="境外客户"
                    @handleSelect="customerSelect"
                    ></ab-select>
                </el-col>
                <el-col :span="4">
                    <el-select
                        size="mini"
                        v-model="formSearch.isUnpaidDay"
                        placeholder="超60天未结汇"
                        clearable
                    >
                        <el-option label="是" :value="true"></el-option>
                        <el-option label="否" :value="false"></el-option>
                    </el-select>
                </el-col>
                <!-- <el-col :span="4">
                    <ab-select
                        v-model="formSearch.bizTypeName"
                        url="/bas/basBizType/list"
                        :urlData="{ name: formSearch.bizTypeName, bizTypeGroup: '02',notNumbers: ['06'], pageNum: 1, pageSize: 10, isEnabled: 1 }"
                        inputKey="name"
                        placeholder="业务类型"
                        @handleSelect="bizTypeSelect"
                    ></ab-select>
                </el-col> -->
                <el-col :span="4">
                    <ab-timeSearch
                    class="searchBox"
                    startSrc="订单日期起"
                    endSrc="订单日期止"
                    v-model="formSearch.coreBillDateArray"
                    @searchEvent="coreBillDateChange"
                    ></ab-timeSearch>
                </el-col>

                <el-col
                    :span="4"
                    class="text-left"
                >
                    <el-button @click="searchForm">搜索</el-button>
                    <el-button
                    link
                    class="btn-svg"
                    @click="resetForm"
                    >
                    <ab-svg name="qingchu"></ab-svg>清除
                    </el-button>
                </el-col>
            </el-row>
        </template>

        <template #toolbar>
        <!-- <el-button
          type="primary"
          :loading="loading.add"
          @click="newPage(null)"
          :disabled="multiSelected.length === 0 || multiSelected.some(e => e.status == '02')"
        >批量结汇</el-button> -->

        <el-button
          type="primary"
          :loading="loading.add"
          @click="addPayment"
        >我要结汇</el-button>

        <el-button
          :loading="loading.export"
          @click="exportFile"
        >导出</el-button>
      </template>

      <template #table>
        <ab-table
          class="materialTable"
          ref="table"
          stripe
          showEdit
          showSelection
          selectionWidth="45"
          indexWidth="50"
          widths="100"
          isFilter="operator"
          :column-list="columns"
          :table-list="tableData"
          :dataListLoading="loading.table"
          :handleSelectionChange="selectionChange"
          @filterColumns="filterColumns"
        >
        <template #unpaidDayDesc="scope">
          <div style="color: red" v-html="scope.row.unpaidDayDesc"></div>
        </template>
            <template #operator="scope">
                <el-button
                    type="primary"
                    link
                    @click="newPage(scope.row)"
                >结汇</el-button>
            </template>
            <template #coreBillDate="{row}">
                {{row.coreBillDate?row.coreBillDate.split(' ')[0]:''}}
            </template>
        </ab-table>
      </template>

      <template #page>
        <ab-page
          :pageTotal="page.total"
          :currentPage="page.currentPage"
          :pageSize="page.pageSize"
          :pageSizes="page.pageSizes"
          @searchForm="pageSearch"
        ></ab-page>
      </template>

    </ab-list-query>
  </div>
</template>

<script>
export default {
    name: 'exchange-settlement-list',
    data () {
        return {
            formSearch: {},
            routeQuery: {},
            page: {
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 20, 50, 100],
                total: 0
            },
            tableData: [],
            loading: {
                table: false,
                add: false,
                export: false
            },
            columns: [
                {
                    labels: '订单日期',
                    props: 'coreBillDate',
                    widths: 125,
                    slot: 'slot'
                },
                {
                    labels: '订单编号',
                    props: 'custOrderNo',
                    widths: 120,
                },
                {
                    labels: '报关单号',
                    props: 'customsNumber',
                    widths: 120,
                },
                {
                    labels: '应结汇日期',
                    props: 'shouldDate',
                    widths: 120,
                },
                {
                    labels: '未结汇天数',
                    props: 'unpaidDayDesc',
                    widths: 120,
                },
                {
                    labels: '境外客户',
                    props: 'customerIdDesc',
                    widths: 200,
                },
                {
                    labels: '报关金额',
                    props: 'customsAmount',
                    widths: 120,
                    type: 'money',
                    align: 'right',
                },
                {
                    labels: '币别',
                    props: 'currencyCode',
                    widths: 80,
                },
                {
                    labels: '待结汇金额',
                    props: 'prePaymentAmount',
                    widths: 120,
                    type: 'money',
                    align: 'right',
                },
                
                {
                    labels: '报关日期',
                    props: 'portDate',
                    sort: 'custom',
                    widths: 120
                },
                {
                    labels: '业务类型',
                    props: 'bizTypeDesc',
                    widths: 130,
                },
                
            ],
            multiSelected: []
        }
    },
    activated() {
        let query = this.$route.query || {}
        this.routeQuery = Object.keys(query).length ? query : this.routeQuery
        if (this.routeQuery.bizType) {
            this.formSearch.bizType = this.routeQuery.bizType
            this.formSearch.bizTypeName = this.routeQuery.bizTypeName
        }
        this.searchForm()
    },
    methods: {
        // 我要结汇
        addPayment() {
            if (this.multiSelected.length) {
                this.newPage(null)
            } else {
                this.$router.push({
                path: '/exchange-settlement-detail',
                query: {
                    action: 'add',
                    path: '/exchange-settlement-list'
                }
                })
            }
        },
        customerSelect (row) {
            if (row && row.id) {
                this.formSearch.customerId = row.id
            } else {
                this.formSearch.customerId = ''
            }
            this.searchForm()
        },
        searchForm () {
            this.page.currentPage = 1
            this.getListData()
        },
        resetForm() {
            this.formSearch = {}
        },
        pageSearch(obj) {
            this.page.currentPage = obj.currentPage
            this.page.pageSize = obj.pageSize
            this.getListData()
        },
        bizTypeSelect(row) {
            if (row && row.number) {
                this.formSearch.bizType = row.number
            } else {
                this.formSearch.bizType = ''
            }
            this.searchForm()
        },
        coreBillDateChange(value) {
            if (value) {
                this.formSearch.coreBillDateStart = value[0]
                this.formSearch.coreBillDateEnd = value[1]
            } else {
                this.formSearch.coreBillDateStart = ''
                this.formSearch.coreBillDateEnd = ''
            }
            this.searchForm()
        },
        getListData () {
            let params = Object.assign({}, this.formSearch)
            this.$post('/sms/client/paymentSettle/list', {
                data: params,
                pageNum: this.page.currentPage,
                pageSize: this.page.pageSize
            }, this.loading, 'table').then(({ data }) => {
                if (data && data.code === 'C0000') {
                this.tableData = data.result.list
                this.page.total = data.result.total
                }
            })
        },
        // 付汇
        newPage(row) {
            const list = row ? [ row ] : this.multiSelected
            this.$post('/sms/client/paymentSettle/toPay', list, this.loading, 'add').then(({ data }) => {
                if (data && data.code === 'C0000') {
                data.result.paymentAppBackVoList = data.result.paymentAppBackVoList || []
                data.result.paymentAppCustomsVoList = data.result.paymentAppCustomsVoList || []
                data.result.paymentAppGeneralEntryVoList = data.result.paymentAppGeneralEntryVoList || []
                data.result.paymentAppPayVoList = data.result.paymentAppPayVoList || []
                data.result.paymentAppPreEntrustVoList = data.result.paymentAppPreEntrustVoList || []
                data.result.paymentAppRevVoList = data.result.paymentAppRevVoList || []
                data.result.paymentAppSumAmountVos = data.result.paymentAppSumAmountVos || []
                data.result.billType = data.result.paymentAppVo.billType
                this.$router.push({
                    // path: '/pledging-payment-detail',
                    path: '/exchange-settlement-detail',
                    query: {
                    action: 'wait',
                        result: JSON.stringify(data.result)
                    }
                })
                }
            })
        },
        exportFile () {
            const excelField = this.columns.map(e => e.props)
            const params = Object.assign({}, { data: this.formSearch, excelField: excelField, colTitleMapList: this.columns })
            this.$post('/sms/client/paymentSettle/expList', params, this.loading, 'export').then(({ data }) => {
                if (data && data.code === 'C0000') {
                // 创建隐藏的可下载链接
                var eleLink = document.createElement('a')
                eleLink.download = ''
                eleLink.target = '_blank'
                eleLink.style.display = 'none'
                // 字符内容转变成blob地址
                eleLink.href = data.result
                // 触发点击
                document.body.appendChild(eleLink)
                eleLink.click()
                // 然后移除
                document.body.removeChild(eleLink)
                }
            })
        },
        selectionChange(array) {
            this.multiSelected = array
        },

        filterColumns(array) {
            this.columns = array
        },
    }
}
</script>

<style lang="scss">
.exchange-of-settement {

}
</style>